<template>
	<v-dialog v-model="open" max-width="600" persistent>
		<v-card class="round-card background-1">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Genera {{ $trans(params.model_title) }}</p>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pt-4 body-2">Vuoi generare {{ $trans(params.model_title) }} per
				{{ params.model_translation }} selezionati?
			</v-card-text>
			<v-card-text class="body-2">
                Elementi selezionati:  <span class="body-1 font-weight-medium">{{ allSelected ? allCount : selected.length }}</span>
            </v-card-text>
            <v-alert v-if="frequencyMix" dense text type="warning" class="mx-4 mb-0 body-2">
                I documenti selezionati hanno frequenze di fatturazione diverse:
                {{ frequencyMix.labels.join(', ') }}<span v-if="frequencyMix.missing">, {{ frequencyMix.missing }} senza frequenza</span>.
            </v-alert>
            <v-alert v-else-if="frequencyCheckUnavailable" dense text type="info" class="mx-4 mb-0 body-2">
                Con tutti gli elementi selezionati il controllo delle frequenze di fatturazione miste non è disponibile: verifica manualmente prima di procedere.
            </v-alert>
            <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
				<fields-generator
					v-if="loaded"
					:fieldsset.sync="fieldsset"
					:model.sync="model"
					ref="fieldsgenerator"
				></fields-generator>
			</v-container>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click.native="$emit('close')">Annulla
				</v-btn>
				<v-btn text color="primary" @click.native="generateDocuments()" :loading="loading">Procedi
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import FormsMixin from '@/mixins/FormsMixin'

export default {
	name: 'convert-document-dialog',
    mixins: [FormsMixin],
	props: {
		params: Object,
		selected: Array,
		selectedIds: Array,
		modelDef: String,
		open: Boolean,
		// selezione "tutti" di Crud: il backend risolve l'insieme con select_all sui filtri della tabella
		allSelected: Boolean,
		allCount: Number,
		listFilters: Object,
	},
	data() {
		return {
			model: {'date': moment().format('YYYY-MM-DD')},
			datepicker_menu: {},
			loading: false,
            fieldsset: {},
			loaded: false,
			firstTime: true,
		}
	},

	computed: {
		// Avviso (non bloccante) se la selezione mescola frequenze di fatturazione
		// diverse: attivo solo con la setting check_invoice_frequency (salvata con
		// model 'ddt', il getter dello store cerca per sola chiave), e solo per
		// righe che espongono invoice_frequency (oggi i DDT). Con tutti gli elementi
		// selezionati la selezione la risolve il backend: qui non è valutabile.
		frequencyMix() {
			if(!this.$store.getters.checkSettings('check_invoice_frequency')) {
				return null
			}
			if(this.allSelected) {
				return null
			}
			const rows = (this.selected || []).filter(r => r && ('invoice_frequency' in r))
			if(!rows.length) {
				return null
			}
			const labels = new Set()
			let missing = 0
			rows.forEach(r => {
				if(r.invoice_frequency) {
					labels.add(r.invoice_frequency_text || r.invoice_frequency)
				} else {
					missing++
				}
			})
			if(labels.size > 1 || (labels.size === 1 && missing > 0)) {
				return { labels: [...labels], missing }
			}
			return null
		},

		// Segnala il limite noto: con tutti gli elementi selezionati la selezione la risolve
		// il backend sul filtro, quindi frequencyMix non può valutarla. Mostrato
		// solo dove il controllo avrebbe senso: stessa evidenza di rilevanza di
		// frequencyMix (righe della pagina che espongono invoice_frequency), non solo il
		// modelDef — altrimenti l'avviso comparirebbe anche prima che il
		// backend esponga il campo o in un riuso futuro del dialog.
		frequencyCheckUnavailable() {
			if(!this.allSelected || this.modelDef !== 'ddts') {
				return false
			}
			if(!this.$store.getters.checkSettings('check_invoice_frequency')) {
				return false
			}
			return (this.selected || []).some(r => r && ('invoice_frequency' in r))
		},
	},

	watch: {
		open: {
			handler() {
				if(this.open == true && this.firstTime == true) {
					this.axios.get(this.params.infoUrl).then(response => {
						// get body data
						this.fieldsset = response.data.fields
						this.loaded = true
						this.firstTime = false
						_.forEach(this.fieldsset.fields, (value, key) => {
							if(value.type === 'checkbox') {
								this.$set(this.model, value.key, '')
							}
							if(value.default) {
								this.$set(this.model, value.key, value.default)
							}
						})
					}, response => {
						// error callback
						this.loading = false
					})
				}
			}
		}
	},


	methods: {

		generateDocuments() {

			this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
				if (!result) {
					return this.handleValidationErrorAdvanced()
				}			
				let data = {
					'ids': this.allSelected ? [] : this.selectedIds,
					model: this.model,
					modelDef: this.modelDef,
					select_all: this.allSelected,
					...(this.allSelected ? this.listFilters : {}),
				}
				let convert = this.params.convert
				this.loading = true

				// se model.subtype è proforma, allora metti convert = proforma
				if(this.model.type == 'proformainvoice') {
					convert = 'proformainvoice'
				}
				// nota di credito: dai DDT con causale fatturabile così (es. reso da cliente)
				if(this.model.type == 'creditnote') {
					convert = 'creditnote'
				}

				// Endpoint override opzionale (params.url): consente a un buttonDef di
				// puntare a un endpoint dedicato (es. Genera Ticket Service Desk →
				// saleorders-generate-helpdesktroubles) riusando questo dialog generico.
				// Senza params.url resta il comportamento standard (ddt/fattura).
				let postUrl = this.params.url || ('documents-' + convert + '-generate')
				this.axios.post(postUrl, data).then(response => {
					// get body data
					let data = response.data
					let snackmessage = ''
					let snackcolor = ''
					if(data.status == 'message'){
						snackmessage = data.message
						snackcolor = 'warning'
					} else{
						snackmessage = data.message || 'Generazione Documenti avviata'
						snackcolor = 'success'
					}
					this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

					this.loading = false
					this.$emit('close')
					// Espone la risposta ai consumer single-order (es. GenerateServicedeskButton)
					// per navigare alla risorsa creata. Il host massivo non ascolta 'success'.
					this.$emit('success', data)
				}, response => {
					// error callback
					this.loading = false
				})
			}).catch(() => {

			})				
		}
	},

}
</script>

